"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SearchInputGroupAddon = require("./SearchInputGroupAddon");
Object.keys(_SearchInputGroupAddon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SearchInputGroupAddon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SearchInputGroupAddon[key];
    }
  });
});